// prettier-ignore
import reports from './reports';
import toolkits from './toolkits';
import { anyone, nonStudent } from './access_defs';
import prependAcFn from './prependAcFn';

const rules = {
	noAccessFn: () => (false),
	fns: {
		page: {
			...prependAcFn(nonStudent, {
				...reports,
				...toolkits,
			}),
			'login': anyone,
			'': nonStudent, //home page
			'create-assignment': nonStudent, // redirect
			'gql': anyone,
			'403': anyone,
			'404': anyone,
			'500': anyone,
		},
	},
	get ids(){
		if(!this._ids){
			this._ids = new Map();
			[this.noAccessFn].concat(
				Object.values(this.fns).flatMap(action => Object.values(action))
			).forEach(
				(fn) => this._ids.has(fn) || this._ids.set(fn, `ac_fn_${this._ids.size}`)
			);
		}
		return this._ids;
	},
	get(action, object){
		const fn = (this.fns[action] ?? {})[object] ?? this.noAccessFn;
		return [fn, this.ids.get(fn)];
	}
};
export default rules;
